import React from 'react';
// import * as _ from 'lodash';
import {
  Checkbox,
  ControlLabel,
  FormControl,
  FormGroup,
  Button,
  Modal,
  Row,
  Col,
} from 'react-bootstrap';
import Select from 'react-select';
import {Box} from 'reactjs-admin-lte';
//

export default class EditInputTypePopup extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      ...props.input,
      typeOptions: [
        {label: 'Text', value: 'ui:widget|text'},
        {label: 'Textarea', value: 'ui:widget|textarea'},
        {label: 'Radio', value: 'ui:widget|radio'},
        {label: 'Select', value: 'ui:widget|select'},
        {label: 'Checkbox', value: 'ui:widget|checkbox'},
        {label: 'AutoComplete', value: 'ui:field|InputAutoComplete'},
        {label: 'Date', value: 'ui:field|SelectDateTime'},
        {label: 'CarBrand', value: 'ui:field|SelectCarBrand'},
        {label: 'CarModel', value: 'ui:field|SelectCarModel'},
        {label: 'CarSeries', value: 'ui:field|SelectCarSeries'},
        {label: 'Color', value: 'ui:field|SelectColor'},
        {label: 'SelectWithIcon', value: 'ui:field|SelectWithIcon'},
        {label: 'Customer', value: 'ui:field|SelectCustomer'},
        // {label: 'Range', value: 'ui:widget|range'},
        // {label: 'Email', value: 'ui:widget|email'},
        // {label: 'Url', value: 'ui:widget|url'},
      ],
    };
  }

  openModal = () => {
  };

  closeModal = () => {
  };

  onSave = () => {
    const {props, state} = this;
    props.onSave(Object.assign({}, state));
    props.onHide();
  };

  preFillValues = () => {
    console.log('enter', this.props);
    this.setState({
      ...this.props.input,
    });
  };

  render() {
    const {state, props} = this;
    return (
        <Modal
            onEntered={this.preFillValues}
            show={props.show}
        ><Box>
          <Box.Header border={true}>
            <h2>Edit</h2>
          </Box.Header>
          <Box.Body>
            <FormGroup>
              <ControlLabel>Field Name</ControlLabel>
              <FormControl
                  value={state.name}
                  onChange={(e) => this.setState({name: e.target.value})}
                  type={'text'}>
              </FormControl>
            </FormGroup>
            <FormGroup>
              <ControlLabel>Label</ControlLabel>
              <FormControl
                  value={state.label}
                  onChange={(e) => this.setState({label: e.target.value})}
                  type={'text'}>
              </FormControl>
            </FormGroup><FormGroup>
            <ControlLabel>Placeholder</ControlLabel>
            <FormControl
                value={state.placeholder}
                onChange={(e) => this.setState({placeholder: e.target.value})}
                type={'text'}>
            </FormControl>
          </FormGroup>
            <FormGroup>
              <Checkbox
                  checked={state.required}
                  onChange={(e) => this.setState({required: e.target.checked})}
              >Required
              </Checkbox>
            </FormGroup>
            <FormGroup>
              <ControlLabel>Form Type</ControlLabel>
              <Select
                  clearable={false}
                  value={state.type}
                  onChange={(e) => {
                    console.log(e);
                    this.setState({type: e.value});
                  }}
                  options={state.typeOptions}>
              </Select>
            </FormGroup>
            <Row>
              <Col md={6}>
                <FormGroup>
                  <ControlLabel>Column Offset</ControlLabel>
                  <FormControl
                      value={state.offset}
                      onChange={(e) => this.setState({offset: e.target.value})}
                      type={'number'}>
                  </FormControl>
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup>
                  <ControlLabel>Column Size</ControlLabel>
                  <FormControl
                      value={state.size}
                      onChange={(e) => this.setState({size: e.target.value})}
                      type={'number'}>
                  </FormControl>
                </FormGroup>
              </Col>
            </Row>
            {this.renderSelectOptions()}
            {this.renderAutoCompleteOptions()}
          </Box.Body>
          <Box.Footer>
            <div className={'text-right'}>
              <Button bsStyle={'success'} onClick={this.onSave}>Save</Button>
              &nbsp;&nbsp;
              <Button bsStyle={'default'} onClick={props.onHide}>Close</Button>
            </div>
          </Box.Footer>
        </Box>
        </Modal>
    );
  }

  renderSelectOptions() {
    const {state} = this;

    if ([
          'ui:widget|select',
          'ui:widget|radio',
          'ui:widget|checkbox',
        ].indexOf(state.type) === -1) {
      return '';
    }

    return (
        <div>
          <FormGroup>
            <ControlLabel>
              Enum Values
              <small className={'text-muted'}>(split by ",")</small>
            </ControlLabel>
            <FormControl
                value={state.enums}
                onChange={(e) => this.setState(
                    {enums: e.target.value})}
                type={'textarea'} />
          </FormGroup>

          <FormGroup>
            <ControlLabel>
              Enum Labels
              <small className={'text-muted'}>(split by ",")</small>
            </ControlLabel>
            <FormControl
                value={state.enumNames}
                onChange={(e) => this.setState(
                    {enumNames: e.target.value})}
                type={'textarea'} />
          </FormGroup>
        </div>
    );
  }

  renderAutoCompleteOptions() {
    const {state} = this;

    if ([
          'ui:field|InputAutoComplete',
        ].indexOf(state.type) === -1) {
      return '';
    }

    return (
        <div>
          <FormGroup>
            <ControlLabel>
              Autocomplete Type
            </ControlLabel>
            <FormControl
                value={state.autocomplete_type}
                onChange={(e) => this.setState(
                    {autocomplete_type: e.target.value})}
                type={'textarea'} />
          </FormGroup>

          <FormGroup>
            <ControlLabel>
              Autocomplete Key Name
            </ControlLabel>
            <FormControl
                value={state.autocomplete_label}
                onChange={(e) => this.setState(
                    {autocomplete_label: e.target.value})}
                type={'textarea'} />
          </FormGroup>

          <FormGroup>
            <ControlLabel>
              Autocomplete Value Name
            </ControlLabel>
            <FormControl
                value={state.autocomplete_value}
                onChange={(e) => this.setState(
                    {autocomplete_value: e.target.value})}
                type={'textarea'} />
          </FormGroup>
        </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/component/element/workdoc/popup/EditInputTypePopup.js